// Clyde's per-org settings as FreshOrder sets them from the super-admin org editor
// (Jon, 2026-10-21: agent settings are not for tenant admins yet). The values the
// server accepts and the editor offers.

/** The models Clyde may run on. A stored value outside this list is kept until changed. */
export const CLYDE_MODEL_IDS = ["claude-sonnet-5-5", "claude-opus-5-5", "claude-fable-5-1"] as const;
export type ClydeModelId = (typeof CLYDE_MODEL_IDS)[number];

/** `review_all`: every order waits for the rep; `auto_confirm`: a buyer's YES places it. */
export const CLYDE_OVERSIGHT_MODES = ["review_all", "auto_confirm"] as const;
export type ClydeOversightMode = (typeof CLYDE_OVERSIGHT_MODES)[number];

/**
 * What a tenant admin's pages read from GET /agent/settings: whether Clyde is on (the
 * Clyde tab, the account-list action), the name the intro preview uses, and the
 * supervisor the Start-a-thread dialog prefills as the rep. Nothing else is served.
 */
export type TenantAgentSettingsView = {
  agentEnabled: boolean;
  agentName: string | null;
  supervisorPhone: string | null;
  supervisorName: string | null;
};
